import { useState, useEffect } from 'react';

/**
 * Compara si dos objetos tienen las mismas claves (sin importar el orden)
 */
const hasSameKeys = (obj1, obj2) => {
    const keys1 = Object.keys(obj1).sort((a, b) => a.localeCompare(b));
    const keys2 = Object.keys(obj2).sort((a, b) => a.localeCompare(b));
    return JSON.stringify(keys1) === JSON.stringify(keys2);
};

/**
 * Custom hook to handle filters and filters persistance
 * @param {Object} baseFilters base filters object set with default values
 * @param {String} storageKey LocalStorage key
 * @returns {Object} Object with properties: filters, handleChangeFilters
 */
export const usePersistFilters = (baseFilters, storageKey) => {
    const [filters, setFilters] = useState(() => {
        const storedFilters = localStorage.getItem(storageKey);
        if (storedFilters) {
            try {
                const parsed = JSON.parse(storedFilters);
                if (hasSameKeys(parsed, baseFilters)) {
                    return parsed;
                } else {
                    localStorage.removeItem(storageKey);
                }
            } catch {
                localStorage.removeItem(storageKey);
            }
        }
        return baseFilters;
    });

    useEffect(() => {
        const storedFilters = localStorage.getItem(storageKey);
        if (storedFilters) {
            try {
                const parsed = JSON.parse(storedFilters);
                if (hasSameKeys(parsed, baseFilters)) {
                    setFilters(parsed);
                } else {
                    localStorage.removeItem(storageKey);
                    setFilters(baseFilters);
                }
            } catch {
                localStorage.removeItem(storageKey);
                setFilters(baseFilters);
            }
        } else {
            setFilters(baseFilters);
        }
    }, [storageKey]);

    useEffect(() => {
        localStorage.setItem(storageKey, JSON.stringify(filters));
    }, [filters, storageKey]);

    const handleChangeFilters = (name, value) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            [name]: value,
        }));
    };

    const clearFilters = () => {
        setFilters(baseFilters);
    };

    return {
        filters,
        handleChangeFilters,
        clearFilters,
    };
};
